import { DefaultModel } from 'src/app/core/framework/default.model';
import { Unidade } from 'src/app/farmacia/unidade/unidade.model';
import { Questionario } from 'src/app/questionario/questionario/questionario.model';
import { PerfilDeAcesso } from '../../perfil-de-acesso/model/perfil-de-acesso.model';

export class Usuario extends DefaultModel {

  nome: string;

  cpf: string;

  login: string;

  email: string;

  senha: string;

  perfil: PerfilDeAcesso;

  idExterno: string;

  questionario: Questionario;

  unidade: Unidade;

  evalPin: string;

  uidCatalogoUsuario: string;

  constructor() {
    super();
    this.perfil = new PerfilDeAcesso();
    this.unidade = null;
  }
}
